module.exports = __webpack_public_path__ + "static/media/heroku.fd22df39.svg";